import { createReducer, on } from '@ngrx/store';
import { C4ListResponse } from '@domain/interface/c4-list-response';
import {
	IS_NOT_NULL_OR_UNDEFINED,
	GET_CARRIER_BUSINESS_NAME,
	CAMEL_CASE,
} from 'cargo-chief-commons';
import { UPDATE_TYPE } from '../load-actions-dialog/load-actions-dialog.component';

import { initialState } from './state';
import { LOADS } from './actions';

export const reducers = createReducer(
	initialState,
	on(LOADS.LOADS_LIST.GET, (state) => ({ ...state, loadingLoadsList: true })),
	on(LOADS.LOADS_LIST.SUCCESS, (state, action: C4ListResponse<any>) => ({
		...state,
		loadsList: action?.data || [],
		totalLoads: action?.totalElements || 0,
	})),
	on(LOADS.LOADS_LIST.FAILURE, (state) => ({ ...state, loadingLoadsList: false })),
	on(LOADS.UPDATE_LOAD.SET, (state, action) => ({
		...state,
		loadsList: state.loadsList.map((load) => {
			if (load.id === action.load.id) {
				return Object.assign({}, action.load);
			}
			return load;
		}),
	})),

	on(LOADS.QUOTES_LIST.GET, (state) => ({ ...state, loadingQuotesList: true })),
	on(LOADS.QUOTES_LIST.SUCCESS, (state, action: C4ListResponse<any>) => ({
		...state,
		loadingQuotesList: false,
		quotesList: action.data,
	})),
	on(LOADS.QUOTES_LIST.FAILURE, (state) => ({ ...state, loadingQuotesList: false })),

	on(LOADS.USERS_LIST.SET, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),

	on(LOADS.LOADS_TABLE.SET, (state, action) => ({
		...state,
		loadingLoadsList: false,
		loadsTable: action.loadsList,
	})),

	on(LOADS.SORT.SET, (state, action) => ({
		...state,
		sort: action.sort,
	})),
	on(LOADS.FILTERS.SET, (state, action) => ({
		...state,
		filters: action.filters,
	})),

	on(LOADS.TABS.SET, (state, action) => ({
		...state,
		allTabs: action.allTabs,
	})),
	on(LOADS.USERS_SORT_AND_FILTERS.SET, (state, action) => ({
		...state,
		userSortAndFilters: action.userSortAndFilters,
	})),

	// set tab type
	on(LOADS.CUSTOM_TAB_BOOKED.SET, (state, action) => ({
		...state,
		isCustomTabBooked: action.isCustomTabBooked,
	})),
	on(LOADS.BOOKED_LOADS.SET, (state, action) => ({
		...state,
		isBookedTab: action.isBookedTab,
	})),
	on(LOADS.SET.ACTIVE_TAB, (state, action) => ({
		...state,
		isActiveTab: action.isActiveTab,
	})),
	on(LOADS.SET.CUSTOM_ACTIVE_TAB, (state, action) => ({
		...state,
		isCustomTabActive: action.isCustomTabActive,
	})),
	on(LOADS.SET.OPEN_TAB, (state, action) => ({
		...state,
		isOpenTab: action.isOpenTab,
	})),
	on(LOADS.SET.CUSTOM_OPEN_TAB, (state, action) => ({
		...state,
		isCustomTabOpen: action.isCustomTabOpen,
	})),

	on(LOADS.ACTIONS.BOOKED_LOADS.SUCCESS, (state, action) => ({
		...state,
		loadsList: state.loadsList.map((load) => {
			const updatedLoad = action.data.find((loadUpdated) => loadUpdated.id === load.id);
			if (IS_NOT_NULL_OR_UNDEFINED(updatedLoad)) {
				let loadToUpdate = Object.assign({}, load);
				if (action.updateField == UPDATE_TYPE.CUSTOMER) {
					loadToUpdate.customerName = CAMEL_CASE(action.customer.name);
					loadToUpdate.customerId = action.customer.id;
				} else {
					loadToUpdate.carrier = action.carrier;
				}
				return loadToUpdate;
			}
			return load;
		}),
		loadsTable: state.loadsTable.map((load: any) => {
			const updatedLoad = action.data.find((loadUpdated) => loadUpdated.id === load.loadId);
			if (IS_NOT_NULL_OR_UNDEFINED(updatedLoad)) {
				let loadToUpdate = Object.assign({}, load);
				if (action.updateField == UPDATE_TYPE.CUSTOMER) {
					loadToUpdate.customerName = CAMEL_CASE(action.customer.name);
					loadToUpdate.customerId = action.customer.id;
				} else {
					loadToUpdate.carrierName = CAMEL_CASE(
						GET_CARRIER_BUSINESS_NAME(action.carrier?.businessName, action.carrier?.doingBusinessAs)
					);
				}
				return loadToUpdate;
			}
			return load;
		}),
	}))
);
